import { useEffect, useRef } from 'react';

export default function FinalCTASection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-fade-in');
          }
        });
      },
      { threshold: 0.1 }
    );

    const section = sectionRef.current;
    if (section) {
      const elements = section.querySelectorAll('.animate-on-scroll');
      elements.forEach((el) => observer.observe(el));
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="relative py-20 md:py-28 bg-midnight overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-midnight via-royal-navy/20 to-midnight" />
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-champagne-gold/5 blur-3xl" />

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl mx-auto text-center">
          <div className="animate-on-scroll opacity-0 mb-8">
            <img
              src="https://static.readdy.ai/image/ff63a95a3d068db59710e28833339873/5f5d4b27bd08bed7c22480400cc76e43.png"
              alt="A world-class coach any time you need one"
              className="w-full mx-auto rounded-2xl object-contain"
            />
          </div>

          <h2 className="animate-on-scroll opacity-0 font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-warm-white mb-6">
            You do not need to stay{' '}
            <span className="gold-gradient-text">stuck in your own head.</span>
          </h2>

          <p className="animate-on-scroll opacity-0 text-silver-grey text-base md:text-lg leading-relaxed mb-8">
            Ask your question. Choose your coaching style. Get clarity, confidence, and one useful next step.
          </p>

          <div className="animate-on-scroll opacity-0">
            <a
              href="https://tnt-coach-ai.base44.app"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 px-10 py-4 rounded-full gold-gradient text-midnight font-bold text-lg hover:opacity-90 transition-all duration-300 shadow-xl shadow-champagne-gold/20 whitespace-nowrap"
            >
              <i className="ri-play-circle-line" />
              Start Your First Coaching Session
              <i className="ri-arrow-right-line" />
            </a>
          </div>

          <div className="animate-on-scroll opacity-0 mt-8 flex items-center justify-center gap-6">
            <div className="flex items-center gap-2">
              <i className="ri-check-line text-champagne-gold" />
              <span className="text-silver-grey text-sm">No credit card required</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-check-line text-champagne-gold" />
              <span className="text-silver-grey text-sm">Cancel anytime</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}